module.exports = __webpack_public_path__ + "img/empty-folder.9886444e.svg";